import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked_1",
  "use": "checked_1-usage",
  "viewBox": "0 0 13 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 9\" id=\"checked_1\"><path d=\"M11.962 0L4.226 7.102 1.184 4.306.138 5.25 4.226 9 13 .952 11.962 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol